import type { Action, LEASE_ACTION_TYPES } from '../components/LeaseActions/Actions';
import { ACTION_MAPPINGS } from '../components/LeaseActions/Actions';
import type { MOBILE_HANDOFF_TYPES } from '../constants/stringConstants';

export default class LeaseAction {
  name: LEASE_ACTION_TYPES;
  isDisabled: boolean;
  action: Action;

  constructor(name, isDisabled = false) {
    this.name = name;
    this.action = ACTION_MAPPINGS[name];
    this.isDisabled = isDisabled;
  }

  getLabel = (): string => this.action?.label || `${this.name} label placeholder`;

  getMobileHandoffValue = (): MOBILE_HANDOFF_TYPES => this.action?.mobileHandoffValue;

  getComponent = () => this.action?.component;

  getIcon = (): React.ReactNode => this.action?.icon || null;

  getIconPosition = (): string => this.action?.iconPosition || 'start';

  getEmitAnalyticsEvent = () => this.action?.emitAnalyticsEvent;
}
